import { initSentry } from "etl/services";

export interface WithSentryProps {
    children: React.ReactNode
}

export const WithSentry = (props: WithSentryProps) => {
    const { children } = props;

    initSentry();

    return children;
};
